// @flow

// @deprecated since "Tappable" has been unneccessary and is causing the component un-clickable frequently.
// Use SvgButton instead

import * as React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import useSheet from 'app/jss';
import Icon from './Icon';

type Props = {
  disabled?: boolean,
  link?: string,
  onClick?: () => void,
  classes: object,
  className?: string,
  stopPropagation?: boolean,
  preventDefault?: boolean,
  style?: object,
  onRef?: (ref: any) => void
};

const defaultProps = {
  disabled: false,
  link: undefined,
  onClick: undefined,
  className: '',
  stopPropagation: false,
  preventDefault: false,
  style: undefined,
  onRef: undefined
};

function IconButton(props: Props) {
  const {
    onClick,
    disabled,
    link,
    classes,
    className,
    stopPropagation,
    preventDefault,
    style,
    onRef,
    ...otherProps
  } = props;

  return (
    <Tappable
      component={link ? Link : 'div'}
      className={classNames(classes.iconButton, className, {
        disabled
      })}
      onTap={onClick}
      to={link}
      stopPropagation={stopPropagation}
      preventDefault={preventDefault}
      style={style}
      ref={onRef}
    >
      <Icon {...otherProps} />
    </Tappable>
  );
}

IconButton.defaultProps = defaultProps;

function applyStyles() {
  return {
    iconButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&.disabled': {
        cursor: 'not-allowed !important'
      }
    }
  };
}

export default useSheet(applyStyles)(IconButton);
